import { extendTheme } from '@chakra-ui/react';
import { ColorModeOptions } from '@chakra-ui/color-mode';

import { colors } from './colors';

const CONFIG: ColorModeOptions = {
  useSystemColorMode: false,
};

const theme = extendTheme({
  colors,
  config: CONFIG,
  styles: {
    global: (_props: unknown) => ({
      'html, body, #__next': {
        height: '100%',
      },
    }),
  },
  fonts: {
    heading:
      'Ubuntu, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
    body: 'Ubuntu, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
  },
});

const getTheme = () => {
  return theme;
};

export { getTheme };
